import { util } from "./util";
export var TreeArray;
(function (TreeArray) {
    function init(value) {
        return inner(value, []);
    }
    TreeArray.init = init;
    function inner(value, children = []) {
        return {
            type: "inner",
            value: value,
            children: children
        };
    }
    TreeArray.inner = inner;
    function leaf(value) {
        return {
            type: "leaf",
            value: value
        };
    }
    TreeArray.leaf = leaf;
    function leafs(value) {
        return value.map(leaf);
    }
    TreeArray.leafs = leafs;
    function add(tree, node) {
        tree.children.push(node);
        return node;
    }
    TreeArray.add = add;
    function index(node, indices) {
        return util.index(getPath(node, indices), -1);
    }
    TreeArray.index = index;
    function map(array, f) {
        if (array.type == "leaf")
            return leaf(f(array.value));
        else
            return {
                type: "inner",
                value: array.value,
                children: array.children.map(c => map(c, f))
            };
    }
    TreeArray.map = map;
    function forLeafs(array, f) {
        if (array.type == "leaf")
            f(array.value);
        else
            array.children.forEach(c => forLeafs(c, f));
    }
    TreeArray.forLeafs = forLeafs;
    function fixIndex(node, indices) {
        let result = [];
        let i = 0;
        let current_node = node;
        while (true) {
            if (current_node?.type != "inner")
                return result;
            else {
                let index = i < indices.length ? indices[i] : 0;
                result.push(index);
                current_node = current_node.children[index];
            }
            i++;
        }
    }
    TreeArray.fixIndex = fixIndex;
    function getPath(node, indices) {
        let nodes = [node];
        for (let i of indices) {
            if (node.type != "inner")
                break;
            node = node.children[i];
            nodes.push(node);
        }
        return nodes;
    }
    TreeArray.getPath = getPath;
})(TreeArray || (TreeArray = {}));
